import {RelayNetworkLayer, retryMiddleware, urlMiddleware, authMiddleware, perfMiddleware, gqErrorsMiddleware, batchMiddleware} from 'react-relay-network-layer';
import {getLocale} from './locales';
import {onSignInRefresh} from './app/auth.js';
import myGraphQLLogger from './myGraphQLLogger';
import Token from '../../packages/extension/src/background/Token';

export default function initRelayLayer(url, isPublic) {
	url = url || document.getElementsByTagName('body').item(0).dataset.apihost + '/graphql';
    let supportsLongRequests = false;
    if (document.getElementsByTagName('body').item(0).dataset.longrequests) {
        supportsLongRequests = document.getElementsByTagName('body').item(0).dataset.longrequests === 'true';
    }

	return new RelayNetworkLayer([
        batchMiddleware({
            batchUrl: (req) => url + '?batch=true&locale=' + getLocale(),
        }),
        urlMiddleware({
            /* read configuration from '<body data-apihost=""' */
            url: (req) => url + '?locale=' + getLocale(),
        }),
        myGraphQLLogger(),
        gqErrorsMiddleware({
            disableServerMiddlewareTip: true,
        }),
        perfMiddleware(),
        retryMiddleware({
            fetchTimeout: supportsLongRequests ? 64000 : 32000,
            retryDelays: (attempt) => Math.pow(2, attempt + 4) * 100, // or simple array [3200, 6400, 12800, 25600, 51200, 102400, 204800, 409600],
            forceRetry: (cb, delay) => { window.forceRelayRetry = cb; },
            statusCodes: [500, 503, 504],
            allowMutations: false,
        }),
        authMiddleware(isPublic ? {} : {
            token: () => {
                return Token.get();
            },
            tokenRefreshPromise: (req) => {
                return onSignInRefresh();
            },
        })

    ]);
}
